import React, { useState } from 'react';
import '../Styles/personal.css'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import Google from '../assets/google.png'
import Github from '../assets/github.png'
import Microsoft from '../assets/microsoft.png'

const SignupPersonal = () => {
const [email, setEmail] = useState('');
const [password, setPassword] = useState('');
const [confirmPassword, setConfirmPassword] = useState('');
const [passwordShown, setPasswordShown] = useState(false);
const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);

const handleEmailChange = (e) => {
setEmail(e.target.value);
}

const handlePasswordChange = (e) => {
setPassword(e.target.value);
}

const handleConfirmPasswordChange = (e) => {
setConfirmPassword(e.target.value);
}

const togglePasswordVisibility = () => {
setPasswordShown(!passwordShown);
};

const toggleConfirmPasswordVisibility = () => {
setConfirmPasswordShown(!confirmPasswordShown);
};

const handleSubmit = (e) => {
e.preventDefault();
}

return (
<div className='signup'>
    <div className="header-top">
        <div className='texxt'>
        <h2>Already have an account?</h2>
        <h2><Link to='/pop'>Sign Up</Link></h2>
        </div>
    </div>

    <div className="intro">
        <div className="text">
            <h1 className="title">Welcome To Melody.AI</h1>
            <h2 className="subtitle">Sign up to get started</h2>
        </div>

        <form onSubmit={handleSubmit}>
        <div>
            <label htmlFor="email">Email</label>
            <input type="email" id="email" value={email} onChange={handleEmailChange} />
        </div>
        <div>
            <label htmlFor="password">Password</label>
            <div className="password-input">
            <input
                type={passwordShown ? 'text' : 'password'}
                value={password}
                onChange={handlePasswordChange}
            />

            <div className="icon-wrapper">
                <FontAwesomeIcon
                icon={passwordShown ? faEyeSlash : faEye}
                onClick={togglePasswordVisibility}
                />
            </div>
            </div>
        </div>
        <div>
            <label htmlFor="confirmPassword">Confirm Password</label>
            <div className="password-input">
            <input
                type={confirmPasswordShown ? 'text' : 'password'}
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
            />

            </div>
        </div>
        <button type="submit">Sign up</button>

        <div className="or">
            <div></div>
            <h1>OR</h1>
            <div></div>
        </div>

            <div className="social-login">
                <button className="signup-button">
                <img src={Google} alt="" /> Sign up with Google
                </button>
                <button className="signup-button">
                <img src={Microsoft} alt="" /> Sign up with Microsoft
                </button>
                <button className="signup-button">
                <img src={Github} alt="" /> Sign up with with Github
                </button>
            </div>
        </form>
    </div>
</div>
);
}

export default SignupPersonal;